var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon53Phone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "90%",
    height: "100%",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      margin: "0 auto",
      padding: 20
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "\n >\n", _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 2542 c-64 -34 -74 -67 -67 -227 22 -532 216 -1032 563 -1452 423 -512 1074 -831 1748 -859 126 -5 143 -4 174 13 68 38 71 55 71 363 0 242 -2 279 -18 309 -32 64 -57 74 -203 83 -159 9 -273 29 -396 70 -83 27 -96 29 -125 18 -18 -8 -108 -87 -199 -178 -137 -134 -171 -163 -187 -158 -12 4 -72 40 -135 80 -320 205 -570 464 -745 773 l-41 73 169 161 c167 160 190 190 190 249 0 15 -16 89 -35 165 -26 101 -38 175 -46 283 -18 258 -9 252 -399 252 -257 0 -289 -2 -319 -18z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon53Phone);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_53_Phone.93492121.svg";
export { ForwardRef as ReactComponent };